import { createAction } from '@reduxjs/toolkit';
import { LocalizedVacancyItemResponse } from './vacancies.types';

export const clearVacanciesItemsAction = createAction('vacancies/clear');
export const updatesVacanciesOptionsAction = createAction<LocalizedVacancyItemResponse[]>(
  'vacancies/updatesVacanciesOptions',
);
export const clearVacanciesOptionsAction = createAction('vacancies/clearVacanciesOptions');
